import { useEffect as h } from "react";
import { useSafeLayoutEffect as y, useBooleanEvent as f, useWrapElement as c } from "../../../ariakit-react-utils/esm/hooks.js";
import { createComponent as x, createElement as C, createHook as v } from "../../../ariakit-react-utils/esm/system.js";
import { addGlobalEventListener as O } from "../../../ariakit-utils/esm/events.js";
import { useDisclosureContent as T } from "../disclosure/disclosure-content.js";
import { T as P } from "../__utils-b06e21f1.js";
import { jsx as a } from "react/jsx-runtime";
import { usePortal as k } from "../portal/portal.js";
const b = v((s) => {
  let {
    state: e,
    portal: d = !0,
    hideOnEscape: m = !0,
    hideOnControl: u = !1,
    wrapperProps: r,
    ...t
  } = s;
  const n = e.popoverRef;
  y(() => {
    const o = n.current, i = e.contentElement;
    o && i && (o.style.zIndex = getComputedStyle(i).zIndex);
  }, [n, e.contentElement]);
  const p = f(m), l = f(u);
  return h(() => {
    if (e.open)
      return O("keydown", (o) => {
        if (o.defaultPrevented) return;
        const i = o.key === "Escape" && p(o), E = o.key === "Control" && l(o);
        (i || E) && e.hide();
      });
  }, [e.open, p, l, e.hide]), t = c(t, (o) => /* @__PURE__ */ a("div", {
    role: "presentation",
    ...r,
    style: {
      position: e.fixed ? "fixed" : "absolute",
      top: 0,
      left: 0,
      ...r == null ? void 0 : r.style
    },
    ref: n,
    children: o
  }), [e.fixed, n, r]), t = c(t, (o) => /* @__PURE__ */ a(P.Provider, {
    value: e,
    children: o
  }), [e]), t = {
    role: "tooltip",
    ...t
  }, t = T({
    state: e,
    ...t
  }), t = k({
    portal: d,
    ...t,
    preserveTabOrder: !1
  }), t;
}), N = x((s) => {
  const e = b(s);
  return C("div", e);
});
process.env.NODE_ENV !== "production" && (N.displayName = "Tooltip");
export {
  N as Tooltip,
  b as useTooltip
};
//# sourceMappingURL=tooltip.js.map
